import { useRouter } from '#app'
import { scrollToTop } from '~/utils'
import { BehaviorScrollToTop } from '~/utils/interface'
import { RESET_PASSWORD_SLUG } from '~/constants'
import { modalList } from '~resources/popup-notification'
import { useModal } from '~/composables/common/use-modal'
import { useLogin } from '~/composables/account/use-login'
import { useCommon } from '~/composables/common/use-common'
import { contactUs } from '~/resources/common/contact-us'
import { usePromotion } from '~composables/promotion/use-promotion'

export function notificationPopup(options: {
  icon?: string
  title: string
  description: string
  confirmButtonText?: string
  cancelButtonText?: string
  confirmButtonLink?: string
  callback?: () => void
  confirmCallback?: () => void
  cancelButtonLink?: string
  customClass?: string
  iconClass?: string
}): void {
  const { $notify } = useNuxtApp()
  const { openLinkContact } = useCommon()
  const router = useRouter()
  const { closeAllModal } = useModal()
  const { showModalLogin } = useLogin()
  const { cancelPromotion } = usePromotion()
  const homeRedirectLink = '/'
  const scrollTopTimeOut = 300
  $notify({
    icon: options.icon,
    title: options.title,
    html: options.description,
    confirmButtonText: options.confirmButtonText,
    cancelButtonText: options.cancelButtonText,
    customClass: {
      cancelButton: options.customClass,
      icon: options.iconClass
    },
    confirmButtonFunc: () => {
      closeAllModal()
      if (
        [
          modalList.DEPOSIT_ERROR.title,
          modalList.WITHDRAW_ERROR.title,
          modalList.INSUFFICIENT_BALANCE_ERROR.title,
          modalList.WITHDRAW_PROMOTION.title
        ].includes(options.title)
      ) {
        openLinkContact(contactUs)
      }
      if (options.confirmCallback) {
        options.confirmCallback()
        return
      }
      if (!options.confirmButtonLink) {
        return
      }
      void router.push(options.confirmButtonLink)

      scrollToTop(0, BehaviorScrollToTop.SMOOTH, scrollTopTimeOut)
    },
    cancelButtonFunc: async () => {
      if (modalList.LOGIN_EXPIRED.title === options.title || modalList.CHANGE_PASS_SUCCESS.title === options.title) {
        showModalLogin()
      }
      if (modalList.ERROR_SYSTEM.title === options.title) {
        openLinkContact(contactUs)
      }
      if (modalList.CONFIRM_CANCEL_PROMOTION.title === options.title) {
        await cancelPromotion()
      }
      if (options.callback) {
        options.callback()
        return
      }
      if (!options.cancelButtonLink) {
        return
      }
      if (options.cancelButtonLink !== `/${RESET_PASSWORD_SLUG}`) {
        void router.push(options.cancelButtonLink)
        if (options.cancelButtonLink === homeRedirectLink) {
          closeAllModal()
        }
        scrollToTop(0, BehaviorScrollToTop.SMOOTH, scrollTopTimeOut)
      }
    },
    closePopupFunc: (): void => {
      if (modalList.CHANGE_PASS_SUCCESS.title === options.title || modalList.LOGIN_EXPIRED.title === options.title) {
        window.location.href = '/'
      }
      if (modalList.DEPOSIT_SUCCESS.title === options.title || modalList.EMAIL_SUCCESS.title === options.title) {
        void router.push(options.cancelButtonLink ?? '')
        closeAllModal()
        scrollToTop(0, BehaviorScrollToTop.SMOOTH, scrollTopTimeOut)
      }
    }
  })
}
